// @TODO: Move this file to be attached to the cart_confirm_v1 template, OR
//        figure out a way to not hard-code the template name on line 9
(function($, site) {
  window.site = site || {};
  site.cartConfirm = site.cartConfirm || {};
  site.template = site.template || {};

  site.cartConfirm.commaSeparateNumber = function(val) {
    val = val.toString().replace(/,/g, ''); //remove existing commas first
    var valSplit = val.split('.'); //then separate decimals
    while (/(\d+)(\d{3})/.test(valSplit[0].toString())) {
      valSplit[0] = valSplit[0].toString().replace(/(\d+)(\d{3})/, '$1'+','+'$2');
    }
    if (valSplit.length == 2) { //if there were decimals
      val = valSplit[0] + "." + valSplit[1]; //add decimals back
    } else {
      val = valSplit[0];
    }
    return val;
  }

  site.cartConfirm.launch = function(args) {
    var template = 'bobbi_cart_confirm_v1';
    var $cartConfirm = $('.site-utils__menu .cart_overlay');
    var trans = args.trans;
    var order = trans.order;
    var preOrderCartItems = typeof trans.preorder.items !== 'undefined' ? trans.preorder.items : '';
    var cartItems = args.items.concat(order.samples);
    var offerCodes = (typeof order.offerCodes !== 'undefined')? order.offerCodes: trans.offerCodes;
    var totals = (typeof trans.trans !== 'undefined')? trans.trans.totals: trans.totals;
    var cart_total = (typeof totals !== 'undefined') ? totals.PRODUCT_SUM_W_TAX : totals.TOTAL_COST_W_TAX;
    var totalsWithPreOrder = trans.subtotalWithPreorder;
    var templateData = { items: [] };
    var cartItem;
    if (preOrderCartItems) {
      cartItems = cartItems.concat(preOrderCartItems);
    }

    // Normalize key names in cartItem object. 'prod.PROD_RGN_NAME' --> 'prod_PROD_RGN_NAME'
    for (var i=0; i < cartItems.length; i++) {
      cartItem = cartItems[i];
      templateData.items[i] = {};
      for (var key in cartItem) {
        if (cartItem.hasOwnProperty(key)) {
            templateData.items[i][ key.replace(/\./, '_') ] = cartItem[key];
        }
      }
    }

    templateData.formattedSubtotal = trans.formattedSubtotal;
    templateData.items_count = trans.items_count;

    // Get Template html
    var conf_html = site.template.get({
      name: template,
      data: templateData
    });
    $cartConfirm.html( conf_html );

    $('a.close', $cartConfirm).click(function(event){
      $cartConfirm.addClass('hidden');
      event.preventDefault();
    });

    if (!templateData.items_count - 0) {
      templateData.items_count = '';
    }
    else if (templateData.items_count !== 1) {
      $('.subtotal .items', $cartConfirm).addClass('plural');
    }

    // update bag icon count
    $('.site-utils__item--cart .js-cart_count').html(templateData.items_count);
    // overlay cart count
    $('[data-pg-prop="items_count"]', $cartConfirm).html(templateData.items_count);

    // If an item was just added, just show that item
    // $('.full_view, .add_view', $cartConfirm).removeClass('hidden'); // **NO** per BB-222

    // Set Full Width for Mobile Device
    // TODO: this should be done with CSS, NOT JS
    var $cart_wrapper = $('.cart-confirm-wrapper');
    var buffer = 15;
    if( ($cart_wrapper.length > 0)  && site.client.isMobile) {
      $cart_wrapper.width($(window).width() - buffer );
    }


    if (typeof args.newItemProdId !== 'undefined') {
      $('[data-product_id="' + args.newItemProdId + '"][data-sku_id="' + args.newItemSkuId + '"]', $cartConfirm)
        .first()
        .addClass('last-item-added')
        .prependTo('.full_view .cart-products');
      // set success msg
      $('.add_view .added_count').html(args.newItemQty);
      $('.add_view .added_msg').html(
        (args.newItemQty === 1) ? $('[data-localtrans="cart_confirm_success_msg_singular"]').html() : $('[data-localtrans="cart_confirm_success_msg_plural"]').html()
      );
      // add a copy of the newly added product row to the "add view"
      $('.add_view .cart-products').html($('[data-product_id="' + args.newItemProdId + '"][data-sku_id="' + args.newItemSkuId + '"]', $cartConfirm).clone().detach());

      //Hide QTY of the newly added product
      var $ele = $('.add_view .cart-products').find('.qty');
      if($ele.length > 0) {
        $ele.hide();
      }

      //Hide Checkout button of the newly added product
      $ele = $('.add_view .checkout').find('a.button');
      if($ele.length > 0) {
        $ele.hide();
      }

      // hide full view
      // $('.full_view', $cartConfirm).addClass('hidden'); // **NO** per BB-222

      // set add-item view on a 10 second timer
      setTimeout(function(){
        if($('.full_view', $cartConfirm).hasClass('hidden')) {
          $('.site-utils__item--cart .cart_overlay').addClass('hidden');
        }
      }, 10000);
    } else { // hide add-item view (show full view)
      $('.add_view', $cartConfirm).addClass('hidden');
    }

    // add any applicable cart_overlay_promos
    /* TODO: make an array of promos possible again with new translation framework */
    $('.full_view .promos').html(site.template.get({ name: 'cart_overlay_promo_v1'}));
    //offerCodes.push('default_free_ship');
    //for(var j = 0; j < offerCodes.length; j++){
    //  $('.full_view .promos').append($('script.inline-template[path="cart_confirm_promo_'+offerCodes[j]+'"]').html());
    //}

    //$('.subtotal .sub_t .sub_num', $cartConfirm).html(parseFloat(totals.PRODUCT_SUM_W_TAX).toFixed(2));
    $('.subtotal .sub_t .sub_num', $cartConfirm).html(site.cartConfirm.commaSeparateNumber(parseInt(cart_total)));

    if (preOrderCartItems) {
      $('.subtotal .sub_t .sub_num', $cartConfirm).html(site.cartConfirm.commaSeparateNumber(Number(totalsWithPreOrder)));
    }

    // initialize custom scrollpane (buggy at the moment...)
    // $('.cart-products', $cartConfirm).first().jScrollPane();

    // close confirm overlay on scroll
    $(window).scroll(function() {
      $('a.close', $cartConfirm).click();
    });

    // all set, show overlay
    $('.site-utils__item--cart .cart_overlay').removeClass('hidden');
  };

  /* cart event */
  $(document).bind('addToCart.success', function(e, cartResult) {
    generic.overlay.hide();

    if (_.isUndefined(cartResult.trans_data) || _.isUndefined(cartResult.ac_results)) {
      return;
    }
    var args = {
      trans: cartResult.trans_data,
      items: cartResult.trans_data.order.items,
      newItemProdId: cartResult.ac_results[0].result.CARTITEM['prod.PRODUCT_ID'],
      newItemSkuId: cartResult.ac_results[0].result.CARTITEM['sku.SKU_ID'],
      newItemQty: Math.max(1, cartResult.ac_results[0].result.CARTITEM.ITEM_QUANTITY - cartResult.ac_results[0].result.PREVIOUS_ITEM_QUANTITY)
    };

    site.cartConfirm.launch(args);

  });
  $(document).on('addToCart.failure', function(e, errorObjects) {
    var errorText = '';
    $.each(errorObjects, function(i, msg) {
      errorText += msg.text + '<br />';
    });
    generic.overlay.launch({
      content: errorText,
      cssStyle: {
        width: '300px',
        height: 'auto'
      }
    });
  });

  Drupal.behaviors.cartConfirm = {
    attach: function(context) {

      /* mouseover icon event */
      var loading = false;

      if(site.client.isMobile){
        $('.site-utils__item--cart', context).click(function(event) {
          if (!$(event.target).closest('.close').length) {
            window.location = '/checkout/viewcart.tmpl';
          }
        });
      } else if ($('.site-utils__item--cart', context).length) {
        $('.site-utils__item--cart', context).mouseover(function(){
          // re-init cookie to be sure it has the latest item count (this won't cause an additional rpc call)
          site.userInfoCookie.init();
          var item_count = site.userInfoCookie.getValue('item_count');

          if ($('.cart_overlay', this).html() === '' && !loading) {
            // no cart drawn yet, check user to see if items in cart, if so, make a trans rpc call...
            if(item_count > 0) {
              // show loading icon while we wait for the rpc response
              var conf_loading = site.template.get({ name: 'bobbi_cart_confirm_v1', data: {loading: true}});
              $('.site-utils__menu .cart_overlay', context).html(conf_loading);
              loading = true;

              generic.jsonrpc.fetch({
                "method": "trans.get",
                "params": [{
                    "trans_fields" : ["TRANS_ID", "totals"],
                    "payment_fields" : [],
                    "order_fields" : ["items", "samples", "offerCodes"]
                }],
                "onSuccess" : function (d) {
                  loading = false;

                  var cartResponse = d.getValue();
                  if ((typeof(cartResponse) === 'undefined') || !cartResponse){
                    return;
                  }

                  var args = {
                    trans: cartResponse,
                    items: cartResponse.order.items
                  };

                  site.cartConfirm.launch(args);
                },
                onError: function() {
                  loading = false;
                }
              });
            }
          }else if($('.site-utils__item--cart .cart_overlay', context).hasClass('hidden')){
            // only show if items in cart
            if(item_count > 0) {
              // show the cart that's already there
              $('.cart_overlay .full_view, .cart_overlay .add_view', context).removeClass('hidden');
              $('.cart_overlay .add_view', context).addClass('hidden');
              $('.site-utils__item--cart .cart_overlay', context).removeClass('hidden');
            }
          }
        }).mouseout(function(){
          $('.cart_overlay', this).addClass('hidden');
        });
      }// breakpoint

      if (!this.attached) {
        this.attached = true;
        site.userInfoCookie.init();
      }
    },
    attached: false
  };
  var headerCustHeight = 54;
  $('.customer-service-section #corporate-privacy-content a[href^="#"]').bind('click', function(evt) {
    evt.preventDefault();
    var target = $(this).attr('href'); //Get the target
    var scrollToPosition = $(target).offset().top - headerCustHeight;
    $('html,body').animate({ 'scrollTop': scrollToPosition }, 0);
  });
})(jQuery, window.site || {});
